import { PropsWithChildren, useEffect, useMemo, useState, useRef, SyntheticEvent } from 'react';
import { TabsContext, TabsContextValue } from './TabsContext';
import { TabValueType } from './interfaces';

export interface TabProviderProps {
  defaultTab?: TabValueType;
  currentTab?: TabValueType;
  onChange?: (value: TabValueType) => void | undefined;
  onClick?: (value: TabValueType) => void | undefined;
}

export function TabProvider({
  defaultTab,
  currentTab,
  onChange,
  onClick,
  children
}: PropsWithChildren<TabProviderProps>) {
  const initialActiveTab = currentTab || defaultTab || 0;
  const [activeTab, setActiveTab] = useState<TabValueType>(initialActiveTab);
  const componentMap = useRef(new Map<string, boolean>());

  useEffect(() => {
    if (currentTab) {
      setActiveTab(currentTab.toString().split('/')[0]);
    }
  }, [currentTab]);

  const values: TabsContextValue = useMemo(
    () => ({
      selectedTab: activeTab,
      onSelected: (_: SyntheticEvent | null, selectedValue: TabValueType) => {
        setActiveTab(selectedValue);

        if (onChange) {
          onChange(selectedValue);
        }
      },
      panelComponentMountMap: componentMap.current,
      onClick: (value: TabValueType) => {
        if (onClick) {
          onClick(value);
        }
      }
    }),
    [activeTab]
  );

  return <TabsContext.Provider value={values}>{children}</TabsContext.Provider>;
}
